import { gql } from '@apollo/client';

export const GET_HIGHLIGHTED_BRANDS = gql`
	query {
		brandsHighlighted {
			id
			brand_story
			name
			url_logo
		}
	}
`;
